import { Card, Col, Row, CardBody, CardHeader } from "reactstrap";
import { translate } from "react-switch-lang";

import styles from "./news.module.scss";
import NewsCard from "./news-card/newsCard";
import { useEffect, useState } from "react";
import { useHttpClient } from "../../security/hooks/axiosProvider";
import { Scrollbars } from "react-custom-scrollbars";

const New = (props: any) => {
  const httpClient = useHttpClient(false);
  const [listNews, setListNews] = useState([]);
  useEffect(() => {
    httpClient.current?.get("/news").then(response => {
      setListNews(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);
  return (
    <Card>
      <CardHeader className={styles["actuality-card-header"]}>
        <div className={styles["actuality-title"]}>{props.t("title_news")}</div>
      </CardHeader>
      <Scrollbars style={{ height: 630 }}>
        <CardBody className={styles["actuality-card-body"]}>
          <Row>
            {listNews.map((data: any, index) => {
              return (
                <Col xl="12" md="12" key={index}>
                  <NewsCard data={data} index={index} />
                </Col>
              );
            })}

            {listNews.length === 0 && (
              <Col xl="12">
                <div className="no-favourite">
                  <span>{props.t("message_no_news")}</span>
                </div>
              </Col>
            )}
          </Row>
        </CardBody>
      </Scrollbars>
    </Card>
  );
};

export default translate(New);
